import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import PsContext from "../../context";
import { ServiceUrl } from "../../utils/serviceUrl";
import { LOADER_LOGO } from "../../utils";

const AnnouncementsList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    axios
      .get(ServiceUrl.LIST_PAGES + "?type=announcement&upcoming=1")
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        }
        setLoader(false);
      });
  };

  return (
    <div style={{ maxHeight: "500px" }}>
      {loader && (
        <center className="py-5">
          <img src={LOADER_LOGO.default} />
        </center>
      )}
      <section className="py-4">
        <div className="container card pad-bot-70 pg-inn ps_min_height ">
          <div>
            {dataList.length > 0 && (
              <>
                {dataList.map((item, i) => {
                  return (
                    <div
                      className="p-3 "
                      style={{ borderBottom: "2px solid #ebebeb" }}
                      dangerouslySetInnerHTML={{
                        __html: item.content_html,
                      }}
                    />
                  );
                })}
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AnnouncementsList;
